// extracted by mini-css-extract-plugin
export var details = "_gt-0";
export var inspectorPopover = "_gt-1";